import { useQueryClient } from '@tanstack/react-query';
import { http } from 'services/http';
import { CLIENT_GET_ONE, CLIENTS_GET_MANY, TRANSPORTS_LIST } from 'api/query-keys.ts';
import type { ClientRes, UpdateClientReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

type THandleSuccessFn = (data: ClientRes) => void;

interface IAuthSmsMutationOptions {
  handleSuccess?: THandleSuccessFn;
}

export const useUpdateClient = (clientId: number, options?: IAuthSmsMutationOptions) => {
  const queryClient = useQueryClient();

  return useMutationBase<ClientRes, unknown, UpdateClientReq>({
    mutationFn: async (variables) => {
      const res = await http.patch<ClientRes>(`/v1/clients/${clientId}`, variables);

      return res.data;
    },
    onSuccess: async (data) => {
      if (options?.handleSuccess) options.handleSuccess(data);

      queryClient.setQueryData([CLIENT_GET_ONE, data.id], data);
    },
    invalidateCallback: () => [[CLIENTS_GET_MANY], [TRANSPORTS_LIST]],
  });
};
